// App.js - Main application file with routing

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

// Import your existing components
import WelcomePage from './Pages/WelcomePage';
import OrderPage from './Pages/OrderPage';
import SummaryPage from './Pages/SummaryPage';
import WaitingPage from './Pages/WaitingPage';
import AboutUs from './Pages/AboutUs';
import QRValidator from './Components/QRValidator';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const hasValidQR = sessionStorage.getItem('hasValidQR');
  
  // If no valid QR session, redirect to about us
  if (!hasValidQR) {
    return <Navigate to="/about_us" replace />;
  }
  
  return children;
};

// Waiting Page Wrapper with timeout
const WaitingPageWrapper = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Set a 5-minute timeout
    const timeout = setTimeout(() => {
      // Clear session and redirect to about us
      sessionStorage.clear();
      navigate('/about_us');
    }, 5 * 60 * 1000); // 5 minutes
    
    return () => clearTimeout(timeout);
  }, [navigate]);
  
  return <WaitingPage />;
};

// Main App Component
function App() {
  return (
    <Router>
      <Routes>
        {/* QR Code validation route */}
        <Route path="/verify/:combinedCode" element={<QRValidator />} />
        
        {/* Protected routes - require valid QR code */}
        <Route path="/" element={
          <ProtectedRoute>
            <WelcomePage />
          </ProtectedRoute>
        } />
        
        <Route path="/order" element={
          <ProtectedRoute>
            <OrderPage />
          </ProtectedRoute>
        } />
        
        <Route path="/order/:qrCode" element={
          <ProtectedRoute>
            <OrderPage />
          </ProtectedRoute>
        } />
        
        <Route path="/summary" element={
          <ProtectedRoute>
            <SummaryPage />
          </ProtectedRoute>
        } />
        
        <Route path="/waiting" element={
          <ProtectedRoute>
            <WaitingPageWrapper />
          </ProtectedRoute>
        } />
        
        {/* About Us - always accessible */}
        <Route path="/about_us" element={<AboutUs />} />
        
        {/* Catch all - redirect to about us */}
        <Route path="*" element={<Navigate to="/about_us" replace />} />
      </Routes>
    </Router>
  );
}

export default App;